import React, { FunctionComponent, useState, useContext } from 'react';
import { useHistory } from 'react-router-dom';
import { makeStyles } from '@mui/styles';
import { Button, Card, CardActionArea, CardMedia, CardContent, Typography, Grid } from '@mui/material';
import { useForm, useFieldArray, Controller } from 'react-hook-form';
import { RebatesContext } from '../../adminSettings/contexts/RebatesContext';
import SearchRebates from '../../../assets/rebates.png';

const SearchRebatesForm = (props) => {
  const history = useHistory();
  const { salesEstimateId } = props;

  const [selectedRebates, setSelectedRebates] = useState([]);

  const { rebates, rebatesLoading } = React.useContext(RebatesContext);

  const selectRebate = (rebateType) => {
    setSelectedRebates((prevSelected) => {
      if (prevSelected.includes(rebateType)) {
        return prevSelected.filter((r) => r !== rebateType);
      } else {
        return [...prevSelected, rebateType];
      }
    });
  };

  const applyRebates = async () => {
    // Make API call here
    // const apiResponse = await fetch('/api/applyRebates', {
    //   method: 'POST',
    //   headers: {
    //     'Content-Type': 'application/json'
    //   },
    //   body: JSON.stringify({ rebateType: selectedRebate })
    // });
    //
    // if (apiResponse.ok) {
    history.push(`/rooftop_automation/${salesEstimateId}/review`);
    // } else {
    //   alert('Failed to apply rebates. Please try again.');
    // }
  };

  return (
    <>
      <Typography variant="h2" sx={{ fontSize: '24px', margin: '-20px 0 20px' }}>
        Automatically Applied HVAC Rebates
      </Typography>
      <Grid container spacing={2}>
        {rebates
          .filter((rebate) => rebate.technology === 'HVAC')
          .map((rebate) => (
            <Grid item xs={12} md={6}>
              <Card
                variant={'outlined'}
                sx={{
                  backgroundColor: '#1976d2',
                  color: '#fff',
                }}
              >
                <CardActionArea>
                  <CardContent>
                    <Typography gutterBottom variant="h5" component="div">
                      {rebate.name}
                    </Typography>
                    <Typography variant="body2" color="text.secondary" style={{ color: 'white' }}>
                      Technology: {rebate.technology}
                    </Typography>
                    <Typography variant="body2" color="text.secondary" style={{ color: 'white' }}>
                      Specifx L2 Description: {rebate.l2_description}
                    </Typography>
                    <Typography variant="body2" color="text.secondary" style={{ color: 'white' }}>
                      Source: {rebate.source}
                    </Typography>
                    <Typography variant="body2" color="text.secondary" style={{ color: 'white' }}>
                      Rebate Rate:{' '}
                      {rebate.min_rebate_rate === rebate.max_rebate_rate
                        ? rebate.min_rebate_rate
                        : `${rebate.min_rebate_rate}-${rebate.max_rebate_rate}/${rebate.rebate_uom}`}
                    </Typography>
                  </CardContent>
                </CardActionArea>
              </Card>
            </Grid>
          ))}
      </Grid>
      <br />
      <hr />
      <br />
      <Typography variant="h2" sx={{ fontSize: '24px', margin: '20px 0' }}>
        Select Optional Rebates
      </Typography>
      <Grid container spacing={2}>
        {rebates
          .filter((rebate) => rebate.technology !== 'HVAC')
          .map((rebate) => (
            <Grid item xs={12} md={6}>
              <Card
                variant={selectedRebates.includes(rebate.id) ? 'outlined' : 'elevation'}
                sx={{
                  backgroundColor: selectedRebates.includes(rebate.id) ? '#1976d2' : '#fff', // Conditional background color
                  color: selectedRebates.includes(rebate.id) ? '#fff' : 'inherit', // Adjust text color for better visibility on blue background
                }}
              >
                <CardActionArea onClick={() => selectRebate(rebate.id)}>
                  <CardContent>
                    <Typography gutterBottom variant="h5" component="div">
                      {rebate.name}
                    </Typography>
                    <Typography
                      variant="body2"
                      color="text.secondary"
                      style={{ color: selectedRebates.includes(rebate.id) ? 'white' : 'black' }}
                    >
                      Technology: {rebate.technology}
                    </Typography>
                    <Typography
                      variant="body2"
                      color="text.secondary"
                      style={{ color: selectedRebates.includes(rebate.id) ? 'white' : 'black' }}
                    >
                      L2 Description: {rebate.l2_description}
                    </Typography>
                    <Typography
                      variant="body2"
                      color="text.secondary"
                      style={{ color: selectedRebates.includes(rebate.id) ? 'white' : 'black' }}
                    >
                      Source: {rebate.source}
                    </Typography>
                    <Typography
                      variant="body2"
                      color="text.secondary"
                      style={{ color: selectedRebates.includes(rebate.id) ? 'white' : 'black' }}
                    >
                      Rebate Rate:{' '}
                      {rebate.min_rebate_rate === rebate.max_rebate_rate
                        ? `${rebate.min_rebate_rate_formatted}/${rebate.rebate_uom}`
                        : `${rebate.min_rebate_rate_formatted}-${rebate.max_rebate_rate_formatted}/${rebate.rebate_uom}`}
                    </Typography>
                  </CardContent>
                </CardActionArea>
              </Card>
            </Grid>
          ))}
      </Grid>
      <br />
      <hr />
      <br />
      <Button variant="contained" color="primary" onClick={applyRebates} disabled={!selectedRebates}>
        Apply Rebates
      </Button>
    </>
  );
};

export default SearchRebatesForm;
